<template>
  <div :class="className" />
</template>

<script setup lang="ts">
import { defineProps } from 'vue';

type Color = 'gray' | 'red' | 'purple';
type Props = {
  color: Color;
};
const props = defineProps<Props>();

const className = computed(() => `divider divider--${props.color}`);
</script>

<style scoped>
.divider {
  height: 12px;
}

.divider.divider--gray {
  background-image: repeating-linear-gradient(
    0deg,
    #989898,
    #989898 4px,
    #cbcbcb 4px,
    #cbcbcb 8px,
    #360f00 8px,
    #360f00 12px
  );
}

.divider.divider--red {
  background-image: repeating-linear-gradient(
    0deg,
    #e07769,
    #e07769 4px,
    #f19f94 4px,
    #f19f94 8px,
    #662219 8px,
    #662219 12px
  );
}

.divider.divider--purple {
  background-image: repeating-linear-gradient(
    0deg,
    #6f166f,
    #6f166f 4px,
    #9d449d 4px,
    #9d449d 8px,
    #350035 8px,
    #350035 12px
  );
}
</style>
